import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  const agentSelector = getSettingValueSelector(TargetSelector.Entity, "agent");

  return (state: AppState, props: RootContainerProps): MapProps => {
    return {
      ...props,
      agentId: agentSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
